import { ReactNode } from "react";
import Badge, { BadgeVariant } from "./Badge";

export type ReportVersionStatus =
  | "PREPARED"
  | "SUBMITTED"
  | "ACCEPTED"
  | "REJECTED"
  | "CANCELLED";

interface ReportVersionStatusBadgeProps {
  status: ReportVersionStatus | string;
  children: ReactNode;
  className?: string;
}

export default function ReportVersionStatusBadge({
  status,
  children,
  className = "",
}: ReportVersionStatusBadgeProps) {
  const getVariant = (status: string): BadgeVariant => {
    switch (status) {
      case "PREPARED":
        return "info";
      case "SUBMITTED":
        return "warning";
      case "ACCEPTED":
        return "success";
      case "REJECTED":
        return "error";
      case "CANCELLED":
        return "neutral";
      default:
        return "neutral";
    }
  };

  return (
    <Badge variant={getVariant(status)} className={className}>
      {children}
    </Badge>
  );
}
